module.exports = __webpack_public_path__ + "img/BANNER_SUBTITLE.3ce69127.png";